export function ErrorMessage({
  message,
  title,
  level = "error",
}: {
  message?: string;
  title?: string;
  level?: "info" | "warning" | "error";
}) {
  if (!message) {
    return null; // No message to display
  }

  const alertClass =
    level === "warning"
      ? "alert-warning"
      : level === "error"
        ? "alert-danger"
        : "alert-info";

  return (
    <div className={`alert ${alertClass}`}>
      {title && <h2 className="alert-heading">{title}</h2>}
      <p>{message}</p>
    </div>
  );
}
